import { ComponentBase } from "@tblabs/truffle";


export class HtmlArticle extends ComponentBase<HTMLElement>
{
    constructor(className: string)
    {
        super("article");
        this.Class(className);
    }
}
